<template>
  <div class="bet-slip-value ellipsis" :title="value">{{ value }}</div>
</template>

<script>
export default {
  props: {
    value: [ Number, String ]
  }
}
</script>

<style scoped>
.bet-slip-value {
  background-image: linear-gradient(to top right,#713592,#342d6e);
  border-radius: 5px;
  color: #fff;
  height: 20px;
  line-height: 20px;
  text-align: center;
  padding: 0 5px;
  width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipValue.vue